
















import {Component, Vue} from 'vue-property-decorator';
import {DocumentsModule, MainModule} from '@/store/store.helper';
import * as storeHelper from '@/store/store.helper';
import {NAVBAR_SIDE_ICON, NavBarInterface} from '@/store/types';
import * as enums from '@/types/enums';

Component.registerHooks(['beforeRouteEnter']);

@Component({})
export default class LandingPage extends Vue {
  @DocumentsModule.DocumentsGetter private documentWelcome;
  @MainModule.MainGetter private infoVideo;
  @MainModule.MainGetter private text;

  @storeHelper.RouterModule.RouterGetter
  private getPath: (object) => string;
  @storeHelper.RouterModule.RouterAction
  private push;
  @storeHelper.DisplayModule.DisplayMutation private setNavBar;
  @storeHelper.DisplayModule.DisplayGetter private getColor;

  public beforeRouteEnter(to, from, next) {
    /**
     * if the path is empty -> push to path with the full path
     */
    if (to.path === '/') {
      next((vm) =>
          vm.push({
            path: vm.getPath({name: enums.ROUTE_NAME.welcome, params: {}}),
          })
      );
    } else {
      next();
    }
  }

}
